import { Donvi } from '../quanlythongtin/donvi';
import { ThongtindetaiLinhVuc } from './thongtindetailinhvuc';
import { ThongtindetaiCoquanchutri } from './thongtindetaicoquanchutri';

export class ThongtinDetai {
  id: number;
  ma: string;
  ten: string;
  thoigiantuid: number;
  thoigiantunam: number;
  thoigiantunamthang: number;
  thoigiantunamthangngay: Date;
  thoigiandenid: number;
  thoigiandennam: number;
  thoigiandennamthang: number;
  thoigiandennamthangngay: Date;
  cap: number;
  dmdonvi: Donvi;
  dmdonviid: number;
  dmlinhvuc: ThongtindetaiLinhVuc;
  dmlinhvucid: number;
  dmcoquanchuquan: ThongtindetaiCoquanchutri;
  dmcoquanchuquanid: number;
  nhiemvu: string;
  isactive: number;
  createddate: Date;
  createdbyuserid: number;
  modifieddate: Date;
  modifiedbyuserid: number;
}